/**
 * Forward an error to the New Relic browser agent if it has loaded.
 *
 * The agent is injected via {@link Monitoring} from `<head>` and exposes
 * `window.newrelic.noticeError`. Calling sites (error boundaries) shouldn't
 * have to care whether the agent is configured for the current env, so this
 * helper no-ops cleanly when the global isn't there and swallows any failure
 * inside the agent itself — never let telemetry break rendering.
 */
export function noticeError(
  error: Error | string,
  customAttributes?: Record<string, string | number | boolean>
): void {
  if (typeof window === 'undefined') return
  const nr = window.newrelic
  if (!nr?.noticeError) return
  try {
    nr.noticeError(error, customAttributes)
  } catch {
    // Telemetry failures must not surface to the user.
  }
}
